import { __rest } from "tslib";
import React from 'react';
import { Icon } from '@scp/ui-shared/theme/icons';
import { Spacing } from '@scp/ui-shared/components/layout';
import { Loader } from '@scp/ui-shared/components/Loader';
import { TextField } from './TextField';
var TEXT = {
  DEFAULT_PLACEHOLDER: 'Search',
  DEFAULT_LABEL: 'Search',
  CLEAR_LABEL: 'Clear the Value'
};
/**
 * A simple search component (extends TextField)
 *
 * @example ./__docs__/SearchField.md
 */

export var SearchField = function SearchField(_a) {
  var _a$placeholder = _a.placeholder,
      placeholder = _a$placeholder === void 0 ? TEXT.DEFAULT_PLACEHOLDER : _a$placeholder,
      _a$label = _a.label,
      label = _a$label === void 0 ? TEXT.DEFAULT_LABEL : _a$label,
      disabled = _a.disabled,
      infieldActions = _a.infieldActions,
      isLoading = _a.isLoading,
      props = __rest(_a, ["placeholder", "label", "disabled", "infieldActions", "isLoading"]);

  return React.createElement(TextField, Object.assign({
    placeholder: placeholder,
    label: label,
    hiddenLabel: true,
    hideError: true,
    clearable: true,
    type: "search",
    role: "search",
    icon: React.createElement(Icon, {
      name: "search",
      size: 22
    }),
    disabled: disabled || isLoading,
    infieldActions: isLoading ? React.createElement(Spacing, {
      paddingHorizontal: 4
    }, React.createElement(Loader, {
      size: 20
    })) : infieldActions
  }, props));
};